import infoCenter from './info-center-html';
import optionsBox from './options-box-html';
import gearsSection from './gears-section-html';
import modalInfo from './modal-info-html';
import modalWelcome from './modal-welcome-html';
import modalWidth from './modal-width-html';
import modalGlossary from './modal-glossary-html';
import sideBarNav from './sidebar-nav-html';
import controlsPanel from './controls-panel-html';


export default {
    infoCenter,
    optionsBox,
    gearsSection,
    modalInfo,
    modalWelcome,
    modalWidth,
    modalGlossary,
    sideBarNav,
    controlsPanel   
}


// WEBPACK FOOTER //
// ./src/js/html-modules/html-modules.js